/* PERSONALISATION */

/* 
** See apps.js last lines for splider initialisation
** (needed as app.js loaded as module so cant access Splide class from here)
** Other changes:
** - st-main-product.liquid --> Add button to open personalisation modal + render personalisation snippet
** - st-table-product-cart.liquid + st-mini-cart-content.liquid --> Change bugged text in cart item to correct item properties
*/

if (!customElements.get('custom-personalisation')) {
  class CustomPersonalisation extends HTMLElement {
    constructor() {
      super();

      // Define elements
      this.bodyElem = document.querySelector('body');
      this.closeIconElem = this.querySelector('.close_icon');
      this.radioFontElems = this.querySelectorAll('input[type=radio][name="font"]');
      this.textInput = this.querySelector('#InitialsInput');
      this.textInFullImageElem = this.querySelector('#initialsOnFullImage');
      this.textInZoomImageElem = this.querySelector('#initialsOnZoomImage');
      this.imageFullElem = this.querySelector('#imageFull');
      this.imagesPanelElem = this.querySelector('.images_panel');
      this.formElem = this.querySelector('#personalisationForm');
      this.engravingErrorElem = this.querySelector('#personalisationForm .personalisation_block_error');

      // Define product data
      this.productType = this.dataset.productType;
      this.variantId = this.dataset.variantId;
      this.customProductId = this.dataset.customProductId;
      this.collection = this.dataset.collection
      this.bindEvents();
      this.computeTextSize();
    }

    // Bind events
    bindEvents() {
      // Open personalisation button in product page
      document.querySelector(".product-main .open_personalisation").addEventListener('click', this.open.bind(this));
      
      // Close icon in personalisation modal
      this.closeIconElem.addEventListener('click', this.close.bind(this));

      // Handle text input change
      this.textInput.addEventListener('input', this.handleTextInput.bind(this));

      // Handle window resize
      window.addEventListener('resize', this.computeTextSize.bind(this));

      // Handle radio change
      this.radioFontElems.forEach(radio => radio.addEventListener('change', () =>  {
        this.imagesPanelElem.classList.remove('font_SangBleu', 'font_PetitFormalScript', 'font_Helvetica');
        this.imagesPanelElem.classList.add(`font_${radio.value}`);
      }));

      // Handle form submit
      this.formElem.addEventListener('submit', (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        this.engravingErrorElem.style.display = "none";
        if (formData.get('initials').length < 2 || formData.get('initials').length > 3) {
          this.engravingErrorElem.style.display = "block";
          return;
        }

        const drawer = document.querySelector('cart-drawer')
        
        const items = {
          "items": [
            {
              quantity: 1,
              id: this.customProductId,
              properties: {
                "Product": this.variantId,
                "Letters": formData.get('initials'),
                "Font": formData.get('font'),
                "Collection": this.collection
              }
            },
            {
              quantity: 1,
              id: this.variantId,
              properties: {
                "Letters": formData.get('initials'),
                "Font": formData.get('font')
              }
            }
          ]
        }
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const request = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(items)
        };
        fetch('/cart/add.js', request)
        .then(function() {
          window.ShpCustom.Cart.getCart();
          // location.href = '/cart';
        });

        this.close();
      });
    }

    // Compute text size
    computeTextSize() {
      const imageWidth = this.imageFullElem.getBoundingClientRect().width;
      const imageHeight = this.imageFullElem.getBoundingClientRect().height;

      // Set box and font size
      let boxWidth;
      let boxHeight
      switch (this.productType) {
        case 'Pen_cap':
          boxWidth = imageWidth * 0.0991;
          boxHeight = imageHeight * 0.0826;
          this.textInFullImageElem.style.width = `${boxWidth}px`;
          this.textInFullImageElem.style.height = `${boxHeight}px`;
          this.textInFullImageElem.style.setProperty('--fontSize', `${boxWidth / 3}px`);

          boxWidth = imageWidth * 0.2325;
          boxHeight = imageHeight * 0.1865;
          this.textInZoomImageElem.style.width = `${boxWidth}px`;
          this.textInZoomImageElem.style.height = `${boxHeight}px`;
          this.textInZoomImageElem.style.setProperty('--fontSize', `${boxWidth / 3}px`);
          break;

        case 'Pen_ring':
          boxWidth = imageWidth * 0.1346;
          boxHeight = imageHeight * 0.1001;
          this.textInFullImageElem.style.width = `${boxWidth}px`;
          this.textInFullImageElem.style.height = `${boxHeight}px`;
          this.textInFullImageElem.style.setProperty('--fontSize', `${boxWidth / 3}px`);

          boxWidth = imageWidth * 0.5683;
          boxHeight = imageHeight * 0.4253;
          this.textInZoomImageElem.style.width = `${boxWidth}px`;
          this.textInZoomImageElem.style.height = `${boxHeight}px`;
          this.textInZoomImageElem.style.setProperty('--fontSize', `${boxWidth / 3}px`);
          break;

        case 'Leather':
          boxWidth = imageWidth * 0.0926;
          boxHeight = imageHeight * 0.1335;
          this.textInFullImageElem.style.width = `${boxWidth}px`;
          this.textInFullImageElem.style.height = `${boxHeight}px`;
          this.textInFullImageElem.style.setProperty('--fontSize', `${boxWidth / 2.5}px`);

          boxWidth = imageWidth * 0.2404;
          boxHeight = imageHeight * 0.3141;
          this.textInZoomImageElem.style.width = `${boxWidth}px`;
          this.textInZoomImageElem.style.height = `${boxHeight}px`;
          this.textInZoomImageElem.style.setProperty('--fontSize', `${boxWidth / 2.5}px`);
          break;

        case 'Lighters':
        default:
          boxWidth = imageWidth * 0.0926;
          boxHeight = imageHeight * 0.1335;
          this.textInFullImageElem.style.width = `${boxWidth}px`;
          this.textInFullImageElem.style.height = `${boxHeight}px`;
          this.textInFullImageElem.style.setProperty('--fontSize', `${boxWidth / 2.5}px`);

          boxWidth = imageWidth * 0.2404;
          boxHeight = imageHeight * 0.3141;
          this.textInZoomImageElem.style.width = `${boxWidth}px`;
          this.textInZoomImageElem.style.height = `${boxHeight}px`;
          this.textInZoomImageElem.style.setProperty('--fontSize', `${boxWidth / 2.5}px`);
          break;
      }
    }

    // Handle text input change
    handleTextInput() {
      // Clean text to keep only latin letters
      const text = this.textInput.value;
      const cleanText = text.replace(/[^a-zA-Z]/gi, '').toUpperCase();
      this.textInput.value = cleanText;

      // Display only if 2 or 3 letters
      if (this.textInput.value.length !== 2 && this.textInput.value.length !== 3) {
        this.textInFullImageElem.textContent = "";
        this.textInZoomImageElem.textContent = "";
        return;
      }

      // Update text in image
      const lettersArray = cleanText.split("");
      this.textInFullImageElem.innerHTML = "";
      this.textInFullImageElem.classList.remove("nb_letters_2");
      this.textInFullImageElem.classList.remove("nb_letters_3");
      this.textInFullImageElem.classList.add(`nb_letters_${lettersArray.length}`);
      this.textInZoomImageElem.innerHTML = "";
      this.textInZoomImageElem.classList.remove("nb_letters_2");
      this.textInZoomImageElem.classList.remove("nb_letters_3");
      this.textInZoomImageElem.classList.add(`nb_letters_${lettersArray.length}`);
      
      for (let i = 0; i < lettersArray.length; i++) {
        this.textInFullImageElem.innerHTML += `<span class="letter letter_${i + 1}">${lettersArray[i]}</span>`;
        this.textInZoomImageElem.innerHTML += `<span class="letter letter_${i + 1}">${lettersArray[i]}</span>`;
      }
    }

    // Open the personalisation modal
    open() {
      this.classList.add('open');
      this.bodyElem.style.overflow = 'hidden';
      this.computeTextSize();
    }

    // Close the personalisation modal
    close() {
      this.classList.remove('open');
      this.bodyElem.style.overflow = 'auto';
    }
  }

  customElements.define('custom-personalisation', CustomPersonalisation);
}
